import { Banner } from 'component/banner'
import sizeImg from 'image/sizeM1.png'
import './product.less'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { PlayCircleOutlined } from '@ant-design/icons';
import { ConfigProvider, Modal, Space } from 'antd';
import { useEffect, useState } from 'react';
import { post } from 'request/request';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { selectLocale } from 'store/localeSlice';
import { FullScreenModal } from 'component/modal';

export const ProductM1 = () => {
    const [isModalVisible, setModalVisible] = useState(false)
    const [loopModalVisible, setLoopModalVisible] = useState(false)
    const intl = useIntl();
    const locale= useSelector(selectLocale);

    const [curVideo, setCurVideo] = useState('')
    const [loopList, setLoopList] = useState([])
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const isMobile = navigator.userAgent.match(/(Mobi|Android|iPhone)/i);
    const videoUrl = 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/16981521261414635.m4v';

    const imgBanner1 = [
        {
            title: intl.formatMessage({id: 'productM1.imgBanner.title1'}),
            content: intl.formatMessage({id: 'productM1.imgBanner.con1'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000178408332721.png'
        },
        {
            title: intl.formatMessage({id: 'productM1.imgBanner.title2'}),
            content: intl.formatMessage({id: 'productM1.imgBanner.con2'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000178958908797.png'
        },
        {
            title: intl.formatMessage({id: 'productM1.imgBanner.title3'}),
            content: intl.formatMessage({id: 'productM1.imgBanner.con3'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000178587579861.png'
        },
        {
            title: intl.formatMessage({id: 'productM1.imgBanner.title4'}),
            content: intl.formatMessage({id: 'productM1.imgBanner.con4'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000179137358162.png'
        },
        {
            title: intl.formatMessage({id: 'productM1.imgBanner.title5'}),
            content: intl.formatMessage({id: 'productM1.imgBanner.con5'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000179316182924.png'
        }
    ]
    const imgBanner = [
    {
        title: intl.formatMessage({id: 'productM1.imgBanner2.title1'}),
        content: intl.formatMessage({id: 'productM1.imgBanner2.con1'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000297499263798.png'
    },
    {
        title: intl.formatMessage({id: 'productM1.imgBanner2.title2'}),
        content: intl.formatMessage({id: 'productM1.imgBanner2.con2'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000298464124139.png'
    },
    {
        title: intl.formatMessage({id: 'productM1.imgBanner2.title3'}),
        content: intl.formatMessage({id: 'productM1.imgBanner2.con3'}),
        url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000298109211964.png'
    },
    // {
    //     title: intl.formatMessage({id: 'productM1.imgBanner2.title2'}),
    //     content: intl.formatMessage({id: 'productM1.imgBanner2.con2'}),
    //     url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000298296408734.png'
    // },
    ]

    const proList2 = [
        {
            title: intl.formatMessage({id: 'productM1.proList2.title1'}),
            content: intl.formatMessage({id: 'productM1.proList2.con1'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000401073382413.png'
        },
        {
            title: intl.formatMessage({id: 'productM1.proList2.title2'}),
            content: intl.formatMessage({id: 'productM1.proList2.con2'}),
            url: 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000400675589774.png'
        }
    ]
    const specificationList1 = [
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title1'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con1'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title2'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con2'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title3'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con3'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title4'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con4'})
        },
        // {
        //     name: intl.formatMessage({id: 'productM1.specificationList.title5'}),
        //     con: intl.formatMessage({id: 'productM1.specificationList.con5'})
        // },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title6'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con6'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title7'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con7'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title8'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con8'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title9'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con9'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title10'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con10'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title11'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con11'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title12'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con12'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title13'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con13'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title14'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con14'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title15'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con15'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title16'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con16'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title17'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con17'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title18'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con18'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title19'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con19'})
        }
    ]
    const specificationList2 = [
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title20'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con20'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title21'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con21'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title22'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con22'})
        },
        {
            name: intl.formatMessage({id: 'productM1.specificationList.title23'}),
            con: intl.formatMessage({id: 'productM1.specificationList.con23'})
        }
    ]
    useEffect(() => {
        post('snailcar/website/common/queryReview',{pageNo: 1,pageSize: 999}, {headers: {language: locale}}).then((data:any) => {
            if (data.resultCode === '200' ){
                setLoopList(data.resultBody.data.list)
            }
        })
    }, [])
    return <div className="product-container">
        <div className="product-banner">
            <img className='pc-block' style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17000399119445113.png" alt="" />
            <img className='mobile-block' style={{width: '100%'}} src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17004639807071823.png" alt="" />
            <div className='product-title'>
                <p>{intl.formatMessage({id: 'productM1.title'})}</p>
                {/* <p>{intl.formatMessage({id: 'homeM1.price.num'})}</p> */}
            </div>
            <div className='paly-btn' onClick={() => setModalVisible(true)}>
                <Space><PlayCircleOutlined /><span>{intl.formatMessage({id: 'product.play.btn'})}</span></Space>
            </div>
        </div>
        <div className='banner-wrapper'>
            <div className='banner-title'>
                <div className='title'>{intl.formatMessage({id: 'productM1.banner.title1'})}</div>
                <div className='content'>{intl.formatMessage({id: 'productM1.banner.con1'})}</div>
            </div>
            <Banner data={imgBanner1} type="1"></Banner>
            <div className='banner-title banner-title2'>
                <div className='title'>{intl.formatMessage({id: 'productM1.banner.title2'})}</div>
                <div className='content'>{intl.formatMessage({id: 'productM1.banner.con2'})}</div>
            </div>
            <Banner data={imgBanner} type="3"></Banner>
            <div className='product-banner2  pro-spec-wrapper' style={{marginTop: '0'}}>
                <img src="https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17004656768809651.png" alt="" />
                <div className='banner-con pro-spec-con'>{intl.formatMessage({id: 'productM1.banner.title3'})}</div>
            </div>
        </div>
        <div className='pro-list2' style={{marginTop: '0'}}>
            {proList2.map((item,index:number) => <div key={index} className='pro-item'>
                {index%2===0 && <div className='img-wrapper middle-block-none'><img src={item.url} alt="" /></div>}
                <div className='img-wrapper middle-block'><img src={item.url} alt="" /></div>
                <div className='con-wrapper'>
                    <div>
                        <div className='title'>{item.title}</div>
                        <div className='content'>{item.content}</div>
                    </div>
                </div>
                {index%2!==0 && <div className='img-wrapper middle-block-none'><img src={item.url} alt="" /></div>}
            </div>)}
        </div>
        <div className='banner-wrapper'>
            
            <div>
                <div className='banner-title spec-title'>{intl.formatMessage({id: 'product.banner.con3'})}</div>
                <div className='specification-wrapper specification-block-wrapper'>
                    <div className='spec-right-img'>
                        <img src={sizeImg} alt="" />
                    </div>
                    <ul className='spec-ul'>
                        <li className='title'>{intl.formatMessage({id: 'productR1.specificationList.information'})}</li>
                        {specificationList1.map((item,index) => <li key={index} className='spec-li'>
                            <span className='name'>{item.name}</span>
                            <span className='com'>{item.con}</span>
                        </li>)}
                        {/* <li className='title'>{intl.formatMessage({id: 'productR1.specificationList.Package&LoadingQty'})}</li>
                        {specificationList2.map((item,index) => <li key={index} className='spec-li'>
                            <span className='name'>{item.name}</span>
                            <span className='com'>{item.con}</span>
                        </li>)} */}
                    </ul>
                </div>
            </div>
            <div className='banner-title loop-title'>{intl.formatMessage({id: 'product.customerReviews'})}</div>
            <div className='middle-block-none'>
                <Slider {...settings}>
                    {
                        loopList.map((item:any,index) => <div key={index}>
                            <div className='loopList-item'>
                                <div className='img-div' onClick={() => {setCurVideo(item.video);isMobile ? (window.location.href = item.video) : setLoopModalVisible(true)}}><img src={item.image} alt="" /><PlayCircleOutlined className='icon'/></div>
                                <div style={{flex: 1}}>
                                    <div className='title'>{item.name}</div>
                                    {/* <div className='time'>{item.time}</div> */}
                                    <div className='con'>{item.des}</div>
                                </div>
                            </div>
                        </div>)
                    }
                </Slider>
            </div>
        </div>
        <div className='pro-list2 middle-block' style={{marginTop: 40}}>
            {loopList.map((item:any,index:number) => <div key={index} className='pro-item'>
                <div className='img-div'  onClick={() =>  {setCurVideo(item.video);setLoopModalVisible(true)}}><img src={item.image} alt="" /><PlayCircleOutlined className='icon'/></div>
                <div className='con-wrapper'>
                    <div>
                        <div className='title'>{item.name}</div>
                        <div className='content'>{item.des}</div>
                    </div>
                </div>
            </div>)}
        </div>
        {/* <ConfigProvider
        //   theme={{
        //     token: {
        //       colorPrimary: '#F6D3CE',
        //     },
        //   }}
        >
           {isModalVisible&&<Modal title="" open={isModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setModalVisible(false)}}>
		   <video webkit-playsinline="true" autoPlay playsInline  style={{width: '100%',marginTop: 30}} controls={true} src={'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/businessFile/16981521261414635.m4v'} ></video>
          </Modal>}
          {loopModalVisible&&<Modal title="" open={loopModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setLoopModalVisible(false)}}>
		   <video style={{width: '100%',marginTop: 30}} webkit-playsinline="true" autoPlay playsInline controls={true} src={curVideo} ></video>
          </Modal>}
        </ConfigProvider> */}
        <FullScreenModal setOpen={setModalVisible} open={isModalVisible} url={videoUrl} />
        <FullScreenModal setOpen={setLoopModalVisible} open={loopModalVisible} url={curVideo} />
    </div>
}